/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import has from 'lodash/has';
import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

/**
 * Komunikátor univerzálního nastavení pro Ki-Wi Server.
 * Knihovna utilit pro oprace s nastavením zařízení v `key:value` formátu.
 */
class CommunicatorSettings {
  /**
   * Vytvoří instanci.
   * @param {Object.<string, string>} [json] Část obsahu zařízení ze serveru s nastavením.
   * @returns {CommunicatorSettings} Nová instance.
   */
  constructor(json) {
    if (!isNil(json) && !isObject(json)) {
      throw new TypeError(`Invalid json "${json}".`);
    }
    this.json = json;
  }

  /**
   * Zjistí hodnotu položky nastavení.
   * @param {string} key Klíč, jehož hodnota se má načíst.
   * @returns {null|string} Hodnota nalezené položky nebo `null`.
   */
  get(key) {
    if (!isString(key)) {
      throw new TypeError(`Invalid key "${key}".`);
    }
    const { json } = this;
    if (!has(json, key)) {
      return null;
    }
    const value = json[key];
    if (isNil(value)) {
      return null;
    }
    if (!isString(value)) {
      throw new TypeError(`Invalid value "${value}" for "${key}".`);
    }
    return value;
  }
}

export default CommunicatorSettings;
